import React, { Component } from "react"
import { connect } from "react-redux"
import { toastr } from "react-redux-toastr"
import styles from "./styles.css"
import BigList from "../../components/BigList"
import Button from "react-toolbox/lib/button/Button"
import ExpenseTypeDialog from "./ExpenseTypeDialog"
import { withActions } from "../../utils"
import { withRouter } from "react-router-dom"
import _ from "lodash"
import * as strings from "../../strings"

const BILLING_PHASE_ORDER = {
  "Initial": 0,
  "OnGoing": 1,
  "Final": 2,
}

const EXPENSE_TYPE_COLUMNS = [ {
  title: strings.generalStrings.name,
  key: "name",
}, {
  title: strings.generalStrings.billingPhase,
  key: "billingPhase",
  transform: x => strings.BillingPhaseTranslation[ x ],
}, {
  title: strings.processes.phase,
  key: "debtPhase",
  transform: phases => ( phases || [] )
    .map( phase => strings.DebtPhaseTranslation[ phase ] )
    .sort()
    .join( ", " ),
} ]

class ManageExpenseTypes extends Component {
  props: {
    value: mixed,
    onChange: ( mixed ) => any,
    actions: mixed,
    store: mixed,
    history: mixed,
  }

  state = {
    dialogVisible: false,
    editItemId: null,
  }

  editExpenseType = item => this.setState( {
    editItemId: item.id,
  } )

  updateExpenseType = et => this.props.actions.updateExpenseType( et )
    .then( () => toastr.success( strings.management.expenseTypeUpdated ) )
    .then( () => this.setState( { editItemId: null } ) )
    .catch( () => toastr.error( strings.management.errorUpdatingExpenseType ) )


  deleteExpenseType = item => {
    const { actions } = this.props

    actions.removeExpenseType( item.id )
      .then( () => toastr.success( strings.management.expenseTypeRemoved ) )
      .catch( () => toastr.error( strings.management.errorRemovingExpenseType ) )
  }

  render () {
    const { history } = this.props
    const expenseTypes = _.chain( this.props )
      .get( "expenses.expenseTypes", [] )
      .map( et => ( {
        ...et,
        _onClick: () => history.push( "expenseType/" + et.id ),
      } ) )
      .orderBy( [
        et => BILLING_PHASE_ORDER[ et.billingPhase ],
        "name",
      ], [ "asc", "asc" ] )
      .value()

    return (
      <div className={styles.root}>
        <div className={styles.toolbar}>
          <Button
            icon="add"
            onClick={() => this.setState( {
              dialogVisible: true,
            } )}
            label={strings.management.addExpenseType+'111'}
            raised
            primary
          />
        </div>
        <BigList
          loadMore={() => {}}
          hasMoreItems={() => {}}
          items={expenseTypes}
          columns={EXPENSE_TYPE_COLUMNS}
          onModify={item => this.editExpenseType( item )}
          onDelete={item => this.deleteExpenseType( item )}
        />
        <ExpenseTypeDialog
          visible={this.state.dialogVisible}
          onCancel={() => this.setState( {
            dialogVisible: false,
          } )}
          onSubmit={expenseType => {
            this.props.actions.addExpenseType( expenseType )
              .then( () => {
                this.setState( {
                  dialogVisible: false,
                } )
              } )
          }}
        />
        <ExpenseTypeDialog
          visible={this.state.editItemId !== null}
          defaultValues={_.chain( this.props )
            .get( "expenses.expenseTypes", [] )
            .find( et => et.id === this.state.editItemId )
            .value()
          }
          onCancel={() => this.setState( { editItemId: null } )}
          onSubmit={this.updateExpenseType}
        />
      </div>
    )
  }
}

export default connect(
  store => _.pick( store, [ "expenses" ] )
)( withActions( withRouter( ManageExpenseTypes ) ) )



// WEBPACK FOOTER //
// ./src/views/ManageExpenseTypes/index.jsx